<template>
  <el-dialog
    :title="isPropertyMode ? '新增轮播图' : $t('advertManage.add.title')"
    :visible.sync="visible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('advertManage.add.adName')" prop="adName">
        <el-input
          v-model="form.adName"
          :placeholder="$t('advertManage.add.adNamePlaceholder')"
        />
      </el-form-item>

      <el-form-item :label="$t('advertManage.add.classify')" prop="classify">
        <el-select
          v-model="form.classify"
          :placeholder="$t('advertManage.add.classifyPlaceholder')"
          style="width: 100%"
        >
          <el-option
            v-for="item in classifyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isPropertyMode" label="投放范围" prop="scopeType">
        <el-radio-group v-model="form.scopeType">
          <el-radio
            v-for="item in scopeTypeOptions"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        v-if="form.scopeType === 'COMMUNITY'"
        label="选择小区"
        prop="communityId"
      >
        <el-select
          v-model="form.communityId"
          filterable
          clearable
          :disabled="isPropertyMode && communityOptions.length === 1"
          :loading="communityLoading"
          placeholder="请选择投放小区"
          style="width: 100%"
        >
          <el-option
            v-for="item in communityOptions"
            :key="item.communityId"
            :label="item.name"
            :value="item.communityId"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="广告平台" prop="clientType">
        <el-select
          v-model="form.clientType"
          placeholder="必填，请选择广告平台"
          style="width: 100%"
        >
          <el-option
            v-for="item in clientTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isPropertyMode" label="投放地点" prop="positionType">
        <el-select
          v-model="form.positionType"
          placeholder="必填，请选择投放地点"
          style="width: 100%"
        >
          <el-option
            v-for="item in positionTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!--
      <el-form-item
        :label="$t('advertManage.add.locationTypeCd')"
        prop="locationTypeCd"
      >
        <el-select
          v-model="form.locationTypeCd"
          :placeholder="$t('advertManage.add.locationPlaceholder')"
          style="width: 100%"
        >
          <el-option
            v-for="item in locationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      -->

      <el-form-item
        :label="$t('advertManage.add.advertType')"
        prop="advertType"
      >
        <el-select
          v-model="form.advertType"
          :placeholder="$t('advertManage.add.advertTypePlaceholder')"
          style="width: 100%"
        >
          <el-option
            v-for="item in advertTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('advertManage.add.pageUrl')" prop="pageUrl">
        <el-input
          v-model="form.pageUrl"
          :placeholder="$t('advertManage.add.pageUrlPlaceholder')"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item :label="$t('advertManage.add.seq')" prop="seq">
        <el-input
          v-model="form.seq"
          :placeholder="$t('advertManage.add.seqPlaceholder')"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item :label="$t('advertManage.add.startTime')" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('advertManage.add.startTimePlaceholder')"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item :label="$t('advertManage.add.endTime')" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          :placeholder="$t('advertManage.add.endTimePlaceholder')"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item v-if="!isPropertyMode" :label="$t('advertManage.add.viewType')" prop="viewType">
        <el-select
          v-model="form.viewType"
          :placeholder="$t('advertManage.add.viewTypePlaceholder')"
          style="width: 100%"
        >
          <el-option
            v-for="item in viewTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="form.viewType === '8888'"
        :label="$t('advertManage.add.image')"
        prop="photos"
      >
        <upload-image-url
          ref="uploadImage"
          :limit="1"
          @notifyUploadCoverImage="handleImageChange"
        />
      </el-form-item>

      <div class="dialog-footer">
        <el-button @click="visible = false">{{
          $t("common.cancel")
        }}</el-button>
        <el-button type="primary" @click="handleSubmit">{{
          $t("common.confirm")
        }}</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { saveAdvert } from "@/api/admin/advertManageApi";
import { getCommunityId } from "@/api/community/communityApi";
import { listAdminCommunitys } from "@/api/owner/adminOwnerApi";
import UploadImageUrl from "@/components/upload/UploadImageUrl";
import {
  advertClientTypeOptions,
  advertPositionTypeOptions,
  validateAdvertEndTime,
  validateAdvertPageUrl,
  validateAdvertPhotos,
  validateAdvertSeq,
} from "@/utils/advert";

export default {
  name: "AddAdvert",
  components: {
    UploadImageUrl,
  },
  props: {
    managementMode: {
      type: String,
      default: "PLATFORM",
    },
    managedCommunities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      communityLoading: false,
      communityOptions: [],
      form: {
        adName: "",
        classify: "",
        scopeType: "COMMUNITY",
        communityId: "",
        clientType: "ALL",
        positionType: "HOME_BANNER",
        locationTypeCd: "2000",
        advertType: "",
        pageUrl: "",
        seq: "1",
        startTime: "",
        endTime: "",
        viewType: "8888",
        adTypeCd: "20000",
        locationObjId: "-1",
        vedioName: "",
        photos: [],
      },
      rules: {
        adName: [
          {
            required: true,
            message: this.$t("advertManage.validate.adNameRequired"),
            trigger: "blur",
          },
        ],
        classify: [
          {
            required: true,
            message: this.$t("advertManage.validate.classifyRequired"),
            trigger: "change",
          },
        ],
        clientType: [
          {
            required: true,
            message: "请选择广告平台",
            trigger: "change",
          },
        ],
        scopeType: [
          {
            required: true,
            message: "请选择投放范围",
            trigger: "change",
          },
        ],
        communityId: [
          {
            validator: (rule, value, callback) => {
              if (this.form.scopeType === "COMMUNITY" && !value) {
                callback(new Error("请选择投放小区"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
        positionType: [
          {
            required: true,
            message: "请选择投放地点",
            trigger: "change",
          },
        ],
        locationTypeCd: [
          {
            required: true,
            message: this.$t("advertManage.validate.locationRequired"),
            trigger: "change",
          },
        ],
        advertType: [
          {
            required: true,
            message: this.$t("advertManage.validate.advertTypeRequired"),
            trigger: "change",
          },
        ],
        pageUrl: [
          {
            validator: (rule, value, callback) => validateAdvertPageUrl(this.form, callback),
            trigger: ["blur", "change"],
          },
        ],
        seq: [
          {
            required: true,
            message: this.$t("advertManage.validate.seqRequired"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => validateAdvertSeq(value, callback),
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: this.$t("advertManage.validate.startTimeRequired"),
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: this.$t("advertManage.validate.endTimeRequired"),
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => validateAdvertEndTime(this.form, callback),
            trigger: "change",
          },
        ],
        photos: [
          {
            validator: (rule, value, callback) => validateAdvertPhotos(this.form, callback),
            trigger: "change",
          },
        ],
        viewType: [
          {
            required: true,
            message: this.$t("advertManage.validate.viewTypeRequired"),
            trigger: "change",
          },
        ],
      },
      classifyOptions: [
        { value: "9001", label: this.$t("advertManage.classify.logistics") },
        { value: "9002", label: this.$t("advertManage.classify.catering") },
        { value: "9003", label: this.$t("advertManage.classify.travel") },
        { value: "9004", label: this.$t("advertManage.classify.hotel") },
        { value: "9005", label: this.$t("advertManage.classify.education") },
        { value: "9006", label: this.$t("advertManage.classify.internet") },
      ],
      scopeTypeOptions: [
        { value: "COMMUNITY", label: "指定小区" },
        { value: "GLOBAL", label: "全局" },
      ],
      clientTypeOptions: advertClientTypeOptions,
      positionTypeOptions: advertPositionTypeOptions,
      locationOptions: [
        { value: "1000", label: this.$t("advertManage.location.device") },
        { value: "2000", label: this.$t("advertManage.location.ownerHome") },
        { value: "3000", label: this.$t("advertManage.location.businessHome") },
        { value: "5000", label: this.$t("advertManage.location.serviceHome") },
        {
          value: "6000",
          label: this.$t("advertManage.location.convenienceHome"),
        },
        { value: "4000", label: this.$t("advertManage.location.staffHome") },
      ],
      advertTypeOptions: [
        { value: "1", label: this.$t("advertManage.advertType.site") },
        { value: "2", label: this.$t("advertManage.advertType.outside") },
        { value: "3", label: this.$t("advertManage.advertType.noJump") },
      ],
      viewTypeOptions: [
        { value: "8888", label: this.$t("advertManage.add.image") },
      ],
    };
  },
  watch: {
    "form.scopeType"(value) {
      if (value === "COMMUNITY") {
        this.loadCommunityOptions();
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.validateField("communityId");
        });
        return;
      }
      this.form.communityId = "";
      this.$refs.form && this.$refs.form.clearValidate("communityId");
    },
    "form.advertType"(value) {
      if (value === "3") this.form.pageUrl = "";
      this.$nextTick(() => this.$refs.form && this.$refs.form.validateField("pageUrl"));
    },
    "form.startTime"() {
      if (this.form.endTime) {
        this.$nextTick(() => this.$refs.form && this.$refs.form.validateField("endTime"));
      }
    },
  },
  computed: {
    isPropertyMode() {
      return this.managementMode === "PROPERTY";
    },
  },
  methods: {
    open() {
      this.visible = true;
      this.resetForm();
      this.applyModeDefaults();
      this.loadCommunityOptions();
    },
    async loadCommunityOptions() {
      if (this.isPropertyMode) {
        this.communityOptions = [...this.managedCommunities];
        this.setDefaultCommunity();
        return;
      }
      if (this.communityOptions.length > 0) {
        this.setDefaultCommunity();
        return;
      }
      this.communityLoading = true;
      try {
        const res = await listAdminCommunitys({ page: 1, row: 500 });
        this.communityOptions = res.data || res.communitys || [];
        this.setDefaultCommunity();
      } catch (error) {
        this.$message.error("获取小区列表失败");
      } finally {
        this.communityLoading = false;
      }
    },
    setDefaultCommunity() {
      if (this.form.scopeType !== "COMMUNITY" || this.form.communityId) {
        return;
      }
      const currentCommunityId = getCommunityId();
      const currentCommunity = this.communityOptions.find(
        (item) => item.communityId === currentCommunityId
      );
      this.form.communityId =
        (currentCommunity && currentCommunity.communityId) ||
        (this.communityOptions[0] && this.communityOptions[0].communityId) ||
        "";
    },
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.uploadImage && this.$refs.uploadImage.clearImages();
    },
    applyModeDefaults() {
      if (!this.isPropertyMode) return;
      Object.assign(this.form, {
        scopeType: "COMMUNITY",
        positionType: "HOME_BANNER",
        locationTypeCd: "2000",
        adTypeCd: "20000",
        locationObjId: "-1",
        viewType: "8888",
        vedioName: "",
      });
    },
    handleClose() {
      this.resetForm();
    },
    handleImageChange(images) {
      if (images && images.length > 0) {
        this.form.photos = images;
      } else {
        this.form.photos = [];
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.validateField("photos"));
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();

        const params = {
          ...this.form,
          photos: this.form.photos,
        };
        if (this.isPropertyMode) {
          Object.assign(params, {
            scopeType: "COMMUNITY",
            positionType: "HOME_BANNER",
            locationTypeCd: "2000",
            adTypeCd: "20000",
            locationObjId: "-1",
            viewType: "8888",
            vedioName: "",
          });
        }
        await saveAdvert(params);
        this.$message.success(this.$t("common.operationSuccess"));
        this.$emit("success");
        this.visible = false;
      } catch (error) {
        if (error && error.message) this.$message.error(error.message);
      }
    },
  },
};
</script>
